

















































































import Vue from "vue";
import InputGroup from "@/components/Form/InputGroup.vue";
import RangeSlider from "@/components/Form/RangeSlider.vue";
import { mapState, mapMutations } from "vuex";
import { SET_MARKER_RADIUS, RootState } from "@/store/types";
export default Vue.extend({
  name: "AddressData",

  components: {
    InputGroup,
    RangeSlider,
    Error: () => import("@/components/Form/Error.vue")
  },

  computed: {
    ...mapState({
      survey: state => (state as RootState).survey,
      address: state => (state as RootState).userData.selectedPlace.address,
      location: state => (state as RootState).userData.selectedPlace.location,
      mapCircleRadius: state => (state as RootState).mapCircleRadius,
      error: state => (state as RootState).questionnaireError
    }),

    radius: {
      get(): number {
        return this.$store.state.mapCircleRadius;
      },
      set(value): void {
        this.setmapCircleRadius(value);
      }
    },

    formattedRadius(): string {
      return `${this.radius} m`;
    },

    fieldsDisabled(): boolean {
      return !this.location.lat && !this.location.lng;
    }
  },

  methods: {
    ...mapMutations({
      setmapCircleRadius: SET_MARKER_RADIUS
    })
  }
});
